import { typeOfLazeImage } from "./LazyImage.constants";

import contentImage from "../../assets/images/background-images/lazy-image.png";
import avatarImage from "../../assets/images/undefined.png";

export const lazyImageConfig = {
    [typeOfLazeImage.content]: contentImage,
    [typeOfLazeImage.avatar]: avatarImage,
};
